export default [
  {
    title: "Report",
    icon: "PieChartIcon",
    // title: "รายงาน",
    // icon: "PieChartIcon",
    // tag: '2',
    // tagVariant: 'light-warning',
    route: "dashboard-1",
    // {
    //   title: 'รายละเอียดรายงาน 2',
    //   route: 'dashboard-2',
    // },
  },
  // {
  //   title: 'รายงาน',
  //   route: 'dashboard',
  //   icon: 'HomeIcon',
  // },
];
